(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchor-dropdowns"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 280;
    var EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function animate(panel, fromHeight, toHeight, done) {
      if (prefersReducedMotion() || !panel.animate) {
        panel.style.height = toHeight === null ? '' : toHeight + 'px';
        if (done) done();
        return;
      }
      var anim = panel.animate(
        [{ height: fromHeight + 'px' }, { height: toHeight + 'px' }],
        { duration: DURATION, easing: EASING, fill: 'both' }
      );
      anim.onfinish = function () {
        anim.cancel();
        if (done) done();
      };
    }

    function openDropdown(dd, panel) {
      // Measure target height with panel temporarily set to auto
      panel.style.height = 'auto';
      var target = panel.scrollHeight;
      panel.style.height = '0px';
      dd.setAttribute('data-open', '');
      // Force reflow before animating
      panel.offsetHeight; // eslint-disable-line no-unused-expressions
      animate(panel, 0, target, function () {
        panel.style.height = ''; // back to CSS-managed (auto inside [data-open])
      });
    }

    function closeDropdown(dd, panel) {
      var current = panel.offsetHeight;
      panel.style.height = current + 'px';
      panel.offsetHeight; // reflow
      animate(panel, current, 0, function () {
        panel.style.height = '';
        dd.removeAttribute('data-open');
      });
    }

    function init() {
      var dropdowns = document.querySelectorAll('[data-anchor-dropdown]');
      dropdowns.forEach(function (dd) {
        var toggle = dd.querySelector('[data-anchor-dropdown-toggle]');
        var panel = dd.querySelector('[data-anchor-dropdown-panel]');
        if (!toggle || !panel) return;
        toggle.addEventListener('click', function () {
          var isOpen = dd.hasAttribute('data-open');
          if (isOpen) {
            closeDropdown(dd, panel);
            toggle.setAttribute('aria-expanded', 'false');
          } else {
            openDropdown(dd, panel);
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anchor-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.anchor-tabs__navigation').forEach(function (nav) {
      var items = Array.from(nav.querySelectorAll('.anchor-tabs__item'));

      items.forEach(function (item) {
        item.querySelector('a').addEventListener('click', function () {
          var navRect = nav.getBoundingClientRect();
          var itemRect = item.getBoundingClientRect();
          var itemLeft = itemRect.left - navRect.left + nav.scrollLeft;
          var navWidth = nav.offsetWidth;

          var target = itemLeft - navWidth / 2 + itemRect.width / 2;

          // Second-to-last: also peek the last tab
          var idx = items.indexOf(item);
          if (idx === items.length - 2) {
            var lastItem = items[items.length - 1];
            var lastRect = lastItem.getBoundingClientRect();
            var lastRight = lastRect.right - navRect.left + nav.scrollLeft;
            var peekTarget = lastRight - navWidth + 16;
            target = Math.max(target, peekTarget);
          }

          nav.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fast-facts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /**
     * Parse a formatted stat string like "$1.95M+", "1,600+", "$1,219"
     * Returns { prefix, suffix, numericValue, decimals, isMillion }
     */
    function parseStat(raw) {
      var str = raw.trim();
      var prefix = '';
      var suffix = '';

      // Extract leading dollar sign
      if (str.charAt(0) === '$') {
        prefix = '$';
        str = str.substring(1);
      }

      // Extract trailing plus sign
      if (str.charAt(str.length - 1) === '+') {
        suffix = '+';
        str = str.substring(0, str.length - 1);
      }

      // Detect "M" suffix for millions (e.g., "1.95M")
      var isMillion = false;
      if (str.charAt(str.length - 1) === 'M' || str.charAt(str.length - 1) === 'm') {
        isMillion = true;
        str = str.substring(0, str.length - 1);
      }

      // Detect "K" suffix for thousands (e.g., "2.5K")
      var isThousand = false;
      if (str.charAt(str.length - 1) === 'K' || str.charAt(str.length - 1) === 'k') {
        isThousand = true;
        str = str.substring(0, str.length - 1);
      }

      // Remove commas and parse
      str = str.replace(/,/g, '');
      var numericValue = parseFloat(str);

      if (isNaN(numericValue)) {
        return null;
      }

      // Determine decimal places from the cleaned string
      var decimals = 0;
      var dotIndex = str.indexOf('.');
      if (dotIndex !== -1) {
        decimals = str.length - dotIndex - 1;
      }

      return {
        prefix: prefix,
        suffix: (isMillion ? 'M' : isThousand ? 'K' : '') + suffix,
        numericValue: numericValue,
        decimals: decimals,
        isMillion: isMillion,
        isThousand: isThousand,
        useCommas: raw.indexOf(',') !== -1
      };
    }

    /**
     * Format a number back to display string with prefix, suffix, commas
     */
    function formatNumber(value, parsed) {
      var str = value.toFixed(parsed.decimals);

      // Add commas to the integer part if the original had commas
      if (parsed.useCommas && !parsed.isMillion && !parsed.isThousand) {
        var parts = str.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        str = parts.join('.');
      }

      return parsed.prefix + str + parsed.suffix;
    }

    /**
     * Easing function: easeOutExpo for a satisfying deceleration
     */
    function easeOutExpo(t) {
      return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    }

    /**
     * Animate a single number element from 0 to its target
     */
    function animateNumber(el) {
      var raw = el.getAttribute('data-count-target');
      if (!raw) return;

      var parsed = parseStat(raw);
      if (!parsed) return;

      var duration = 2000;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easeOutExpo(progress);
        var currentValue = easedProgress * parsed.numericValue;

        el.textContent = formatNumber(currentValue, parsed);

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          // Ensure final value matches original exactly
          el.textContent = raw.trim();
        }
      }

      // Start at formatted zero
      el.textContent = formatNumber(0, parsed);
      requestAnimationFrame(step);
    }

    /**
     * Initialize IntersectionObserver for each fast-facts section
     */
    function init() {
      var sections = document.querySelectorAll('.c-fast-facts--reveal');

      if (!sections.length) return;

      // Check for reduced motion preference
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        // Skip animations, just show everything
        sections.forEach(function (section) {
          section.classList.add('c-fast-facts--visible');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var section = entry.target;

              // Add visible class for the CSS reveal animation
              section.classList.add('c-fast-facts--visible');

              // Start count-up animations with a slight delay to sync with the CSS reveal
              var numberEls = section.querySelectorAll('.c-fast-facts__number[data-count-target]');
              setTimeout(function () {
                numberEls.forEach(function (el) {
                  animateNumber(el);
                });
              }, 300);

              // Only animate once
              observer.unobserve(section);
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -50px 0px'
        }
      );

      sections.forEach(function (section) {
        observer.observe(section);
      });
    }

    // Run on DOMContentLoaded or immediately if already loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fundraiser"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.c-fundraiser__block, .c-fundraiser__header').forEach(function(el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
